function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import styles from './LayoutItems.module.scss';
import LayoutItem from '../LayoutItem/LayoutItem';
import SemanticSection from '../../SemanticSection/SemanticSection';
import cs from 'classnames';
import ListItem from '../ListItem';
import kebab from '../../utils/kebab';
import uuid from '../../utils/uuid';
export default function LayoutItems(_ref) {
  var size = _ref.size,
    labelledby = _ref.labelledby,
    orientation = _ref.orientation,
    children = _ref.children,
    level = _ref.level,
    ScreenLinkComponent = _ref.ScreenLinkComponent;
  var nextLevel = level + 1;
  return /*#__PURE__*/React.createElement(SemanticSection, null, /*#__PURE__*/React.createElement("ul", {
    "aria-labelledby": labelledby,
    className: cs(styles.list, styles[orientation], styles["level-".concat(level)], styles["".concat(orientation, "-").concat(level)], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.nested, level > 0), styles["".concat(orientation, "-nested")], level > 0), styles["".concat(orientation, "-deeply-nested")], level > 1), styles["".concat(size)], size))
  }, children ? children.map(function (item) {
    switch (item.type) {
      case 'screen':
        return /*#__PURE__*/React.createElement(ScreenLinkComponent, {
          key: item.screenId,
          id: item.screenId,
          name: item.name,
          level: nextLevel,
          href: item.href,
          orientation: orientation,
          item: item
        });
      case 'text':
        return /*#__PURE__*/React.createElement(ListItem, {
          className: cs(styles["item--".concat(orientation)], styles.text),
          html: item.text
        });
      case 'group':
        var id = "".concat(kebab(item.name), "-").concat(uuid());
        return /*#__PURE__*/React.createElement(LayoutItem, {
          id: id,
          name: item.name,
          orientation: item.orientation,
          level: nextLevel
        }, /*#__PURE__*/React.createElement(LayoutItems, {
          labelledby: id,
          orientation: item.orientation,
          level: nextLevel,
          ScreenLinkComponent: ScreenLinkComponent
        }, item.children));
      default:
        return null;
    }
  }) : null));
}